(function () {
  'use strict';

  var OPEN_CLASS = 'nextdev--faq__answer--open';
  var openPanels = [];

  function open(head, body, sign) {
    body.classList.add(OPEN_CLASS);
    head.setAttribute('aria-expanded', 'true');
    if (sign) sign.textContent = '−';
    body.style.maxHeight = body.scrollHeight + 'px';
    if (openPanels.indexOf(body) === -1) openPanels.push(body);
    var done = function (e) {
      if (e.propertyName !== 'max-height') return;
      if (body.classList.contains(OPEN_CLASS)) body.style.maxHeight = 'none';
      body.removeEventListener('transitionend', done);
    };
    body.addEventListener('transitionend', done);
  }

  function close(head, body, sign) {
    body.style.maxHeight = body.scrollHeight + 'px';
    void body.offsetHeight;
    body.classList.remove(OPEN_CLASS);
    head.setAttribute('aria-expanded', 'false');
    if (sign) sign.textContent = '+';
    body.style.maxHeight = '0px';
    var i = openPanels.indexOf(body);
    if (i > -1) openPanels.splice(i, 1);
  }

  function bind(head) {
    var body = head.nextElementSibling;
    if (!body || head.dataset.nextdevFaqInit) return;
    head.dataset.nextdevFaqInit = '1';
    var sign = head.querySelector('.nextdev--faq__sign');
    body.style.maxHeight = '0px';
    head.addEventListener('click', function () {
      if (body.classList.contains(OPEN_CLASS)) {
        close(head, body, sign);
      } else {
        open(head, body, sign);
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-nextdev-faq]').forEach(bind);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      openPanels.forEach(function (body) {
        body.style.maxHeight = 'none';
      });
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // the theme editor swaps the section out and back in
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();